import { Text } from '@chakra-ui/react';
import { formatDistanceToNow } from 'date-fns';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdate } from 'react-use';

interface INestedChatMessageTimestampProps {
  timestamp: Date;
}

export const NestedChatMessageTimestamp: FC<INestedChatMessageTimestampProps> = ({ timestamp }) => {
  const update = useUpdate();
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      // forcing update every minute for message relative timestamp update
      update();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [timestamp, update]);

  return (
    <Text as="span" color="gray.800" fontSize="xs">
      {t('conversation.timeAgo', { time: formatDistanceToNow(timestamp) })}
    </Text>
  );
};
